// Element Ranking Service
// Purpose: API client for managing ElementRankings CRUD operations
// Endpoints: /api/elementrankings/*

import { apiService } from './api';
import {
  ElementRankingDto,
  CreateElementRankingDto,
  UpdateElementRankingDto,
  UpdateRankingOrderDto,
} from '../types/elementRanking';

export const elementRankingService = {
  /**
   * Get all element rankings
   */
  getAll: async (params?: {
    searchTerm?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
  }) => {
    const queryParams = new URLSearchParams();

    if (params?.searchTerm) {
      queryParams.append('searchTerm', params.searchTerm);
    }
    if (params?.sortBy) {
      queryParams.append('sortBy', params.sortBy);
    }
    if (params?.sortOrder) {
      queryParams.append('sortOrder', params.sortOrder);
    }

    const queryString = queryParams.toString();
    const endpoint = queryString
      ? `/elementrankings?${queryString}`
      : '/elementrankings';

    return apiService.get<ElementRankingDto[]>(endpoint);
  },

  /**
   * Get element ranking by ID
   */
  getById: async (id: number) => {
    return apiService.get<ElementRankingDto>(`/elementrankings/${id}`);
  },

  /**
   * Create new element ranking
   */
  create: async (data: CreateElementRankingDto) => {
    return apiService.post<ElementRankingDto>('/elementrankings', data);
  },

  /**
   * Update existing element ranking
   */
  update: async (id: number, data: UpdateElementRankingDto) => {
    return apiService.put<ElementRankingDto>(`/elementrankings/${id}`, data);
  },

  /**
   * Delete element ranking
   */
  delete: async (id: number) => {
    return apiService.delete<void>(`/elementrankings/${id}`);
  },

  /**
   * Update ranking order for multiple elements
   */
  updateOrder: async (data: UpdateRankingOrderDto) => {
    return apiService.put<void>('/elementrankings/reorder', data);
  },
};
